import UKRegulation from "slotworks/integration/revolver/regulations/uk/uk-regulation";
import settingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import BaseRegulation from "slotworks/integration/revolver/regulations/base-regulation";
import SwedenTopBar from "slotworks/integration/revolver/regulations/sweden/responsible-gambling-links";

// Class for handling additional regulation bar/details
class Regulation {

    private regulation: BaseRegulation;

    public setup() {
        if(settingsModel.isJurisdiction(Jurisdiction.UK)) {
            this.regulation = new UKRegulation();
        } else if(settingsModel.isJurisdiction(Jurisdiction.SE)) {
            this.regulation = new SwedenTopBar();
        } else {
            this.regulation = new BaseRegulation();
        }
        this.regulation.setup();
    }

    public gameReady() {
        this.regulation.gameReady();
    }

    public interactionStart() {
        this.regulation.interactionStart();
    }

    public updateNetPosition(netPosition: number) {
        this.regulation.updateNetPosition(netPosition);
    }
}

const regulation = new Regulation();
export default regulation;


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/integration/revolver/regulations/regulation.ts